import { KNOWN_HOSTS, DEFAULT_HOST, FORCE_SECURE_CONNECTION } from '../config.js';

// Detect server address from the URL
export function detectServerAddress() {
  let host = DEFAULT_HOST;
  if (typeof window.location == 'object') {
    if (window.location.protocol == 'file:' || window.location.hostname == 'localhost') {
      host = KNOWN_HOSTS.local;
    }
  }
  return host;
}

// Detect if the page is served over HTTPS.
export function isSecureConnection() {
  if (FORCE_SECURE_CONNECTION) {
    return true;
  }
  if (typeof window.location == 'object') {
    return window.location.protocol == 'https:';
  }
  return false;
}

export function isLocalHost() {
  if (typeof window.location == 'object') {
    return window.location.hostname == 'localhost';
  }
  return false;
}
